'use strict'

var App = require('app')

/* Views */
var Show = require('./show')

var DeviceSituation = function () {
  /* Routes ----------------------------------------------------------------- */
  /* API -------------------------------------------------------------------- */
  var API = {
    show: function (options) {
      let show = new Show(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('device-situation:show', function (options) {
    API.show(options)
  })
}

module.exports = DeviceSituation



// WEBPACK FOOTER //
// ./js/modules/device-situation/index.js